module.exports = __webpack_public_path__ + "img/cart.2aaea0e.svg?v=1764903765445";